import React, { FC } from 'react'

import colors from '../../theme/colors'
import { Icons } from '../Icon/types'

import * as SC from './styled'

export type BackLinkProps = {
  className?: string
  text: string
  onClick: () => void
}

const BackLink: FC<BackLinkProps> = (props) => {
  const { className, text, onClick } = props

  return (
    <SC.Container className={className} onClick={onClick}>
      <SC.IconStyled icon={Icons.chevronLeft} color={colors.pureBlack} />
      <SC.Text>{text}</SC.Text>
    </SC.Container>
  )
}

export default BackLink
